module.exports = __webpack_public_path__ + "img/food.04318135.png";